// src/data/wardrobeItems.ts

export interface WardrobeItem {
  category: string;
  file: string;           // base filename (no overlay suffix)
  displayName: string;    // friendly label
  cost: number;           // coin cost to unlock
}

export const wardrobeItems: WardrobeItem[] = [
  {
    category: "hats",
    file: "baseball_cap_red.png",
    displayName: "Hat",
    cost: 40,
  },
  {
    category: "glasses",
    file: "sunglasses_black.png",
    displayName: "Sunglasses",
    cost: 50,
  },
  {
    category: "scarves",
    file: "scarf_orange.png",
    displayName: "Scarf",
    cost: 10,
  },
  {
    category: "shoes",
    file: "sneakers_red.png",
    displayName: "Shoes",
    cost: 30,
  },
  {
    category: "oranges",
    file: "orange_orange.png",
    displayName: "Oranges",
    cost: 100,
  },
];
